import { Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { withTranslation } from "react-i18next";
import { NavLink, useSearchParams } from "react-router-dom";
import NormalTabs from "../../../Components/Atoms/Tabs/NormalTabs";
import ReviewCard from "../../../Components/Organisms/Reviews/card";
import CustomPagination from "../../../Components/Atoms/Pagination/Pagination";
import ProgressRating from "../../../Pages/Main/Acticities/ProgressRating";

const ActivityReviewsTemplate = ({
  t,
  reviewsList,
  activityDetails,
  reviewsDetails,
  count,
  handlePageChange,
  page,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  let pageNumber =
    +searchParams.get("page") == 0 ? 1 : +searchParams.get("page");

  const [option, setOption] = useState(0);

  const options = [
    {
      id: 1,
      label: t("branch.diveCenter"),
      value: "DiveCenter",
    },
    {
      id: 2,
      label: t("activity.activity"),
      value: "diveActivity",
    },
    {
      id: 3,
      label: t("joboffer.Instructor"),
      value: "DiveExpert",
    },
  ];

  const handelTabClick = (value) => {
    setOption(value);
    // value == 0 ? setSearchParams({ type: "diveCenter" })
    // : value == 1 ? setSearchParams({ type: "diveActivity" })
    // : value == 2 ? setSearchParams({ type: "diveExpert" }) : null;
    if (value == 0) {
      setSearchParams({ type: "diveCenter" });
    } else if (value == 1) {
      setSearchParams({ type: "diveActivity" });
    } else if (value == 2) {
      setSearchParams({ type: "diveExpert" });
    }
  };

  useEffect(() => {
    // searchParams.get("type") == "diveCenter" ? setOption(0)
    // : searchParams.get("type") == "diveActivity" ? setOption(1)
    // : searchParams.get("type") == "diveExpert" ? setOption(2) : null;
    if (searchParams.get("type") == "diveCenter") {
      setOption(0);
    } else if (searchParams.get("type") == "diveActivity") {
      setOption(1);
    } else if (searchParams.get("type") == "diveExpert") {
      setOption(2);
    }
  }, [searchParams]);

  return (
    <Container maxWidth="XL">
      <Stack flexDirection="row" alignItems="center" gap={1} mb={2}>
        <NavLink
          to={`/activities?page=${pageNumber}`}
          style={{ textDecoration: "none" }}
        >
          <Typography fontSize="18px" color="#bebebe">
            {t("activity.diveActivites")} {">"}
          </Typography>
        </NavLink>
        <NavLink
          to={`/activities/details/${activityDetails?.id}?page=${pageNumber}`}
          style={{ textDecoration: "none" }}
        >
          <Typography fontSize="18px" color="#bebebe">
            {activityDetails?.name} {">"}
          </Typography>
        </NavLink>
        <Typography fontSize="18px" color="#bebebe">
          {t("profile.ratingAndReview")}
        </Typography>
      </Stack>
      <Stack flexDirection="row" alignItems="center" gap={1} mb={2}>
        <Typography
          fontSize="30px"
          fontWeight="bold"
          textTransform="capitalize"
        >
          {t("profile.ratingAndReview")}
        </Typography>

        <Typography color="#3ed181" mx={3}>
          {" "}
          ( {reviewsDetails?.total_reviews} review )
        </Typography>

        <NormalTabs
          type={"add"}
          // formType={formType}
          TabsOptions={options}
          value={option}
          change={(data) => setOption(data)}
          ContainerStyle="switch-container"
          TabStyle="switch-btn mb-20px"
          onclick={handelTabClick}
        />
      </Stack>
      <Grid container xs={12} gap={2}>
        <Grid
          item
          className="activity-form"
          flexDirection="column"
          md={7}
          m="0"
          my="10px"
        >
          {reviewsList?.length > 0 ? (
            reviewsList?.map((reviewData, index) => {
              return (
                <ReviewCard
                  reviewData={reviewData}
                  key={index}
                  visibleDivider={
                    index !== reviewsList?.length - 1 ? true : false
                  }
                />
              );
            })
          ) : (
            <Stack alignItems="center" justifyContent="center" h="100%">
              <Typography>{t("activity.noReviewsMsg")}</Typography>
            </Stack>
          )}
          {count > 10 && (
            <Grid container justifyContent="center" mb={7.5} mt={5}>
              <CustomPagination
                count={Math.ceil(count / 10)}
                size="large"
                shape="rounded"
                page={page}
                handleChange={handlePageChange}
                className="pagination"
              />
            </Grid>
          )}
        </Grid>

        <Grid
          item
          className="activity-form"
          flexDirection="column"
          md={4}
          m="0"
          my="10px"
        >
          <ProgressRating reviews={reviewsDetails} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default withTranslation()(ActivityReviewsTemplate);
